import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import * as _ from 'lodash-es';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { selectUser } from '../store/userData/userData.selector';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard {

  user: any;

  constructor(
    private readonly router: Router,
    private readonly store: Store,
    private readonly authService: AuthService
  ) {
    store.select(selectUser).subscribe(res => {
      if (res) {
        this.user = res;
      }
    });
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return !_.isNil(this.user) ? true : this.router.createUrlTree(['/']);
  }

}
